import { NgModule } from '@angular/core';
import { NzConnectedOverlayDirective } from './nz-connected-overlay';

@NgModule({
  declarations   : [ NzConnectedOverlayDirective ],
  exports        : [ NzConnectedOverlayDirective ]
})
export class NzOverlayModule {

}
